import { useEffect, useRef } from 'react';

const useKeyPress = (key, handler, element, elementID) => {
    const callBackRef = useRef();

    useEffect(() => {
        callBackRef.current = e => {
            if (key === e.key) {
                handler?.(e);
            }
        }
    }, [key, handler]);

    useEffect(() => {
        const listener = e => {
            callBackRef.current(e)
        };

        if (element && element.current && element.current[elementID]) {
            element.current[elementID].addEventListener('keydown', listener);
        } else {
            window.addEventListener('keydown', listener);
        }

        return () => {
            if (element && element.current && element.current[elementID]) {
                element.current[elementID].addEventListener('keydown', listener);
            } else {
                window.removeEventListener('keydown', listener);
            }
        }

    }, []);
};

export default useKeyPress;